export default __webpack_public_path__ + "static/media/barekets_image.69f5dcf5.jpeg";